import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from './ui/sheet';
import { Button } from './ui/button';
import { Pencil, Copy, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const MEAL_TARGETS = ['breakfast', 'lunch', 'dinner', 'snack'];

export default function FoodEntryActionSheet({ entry, currentMealType, open, onOpenChange, onEdit, onDuplicate, onDelete }) {
  const { t } = useTranslation();
  const [duplicateOpen, setDuplicateOpen] = React.useState(false);

  React.useEffect(() => {
    if (!open) setDuplicateOpen(false);
  }, [open]);

  if (!entry) return null;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="p-0 max-h-[60vh]">
        <SheetHeader className="p-4 border-b border-border/50">
          <SheetTitle className="truncate">{entry.food_name}</SheetTitle>
        </SheetHeader>
        <div className="p-3 space-y-2">
          {!duplicateOpen ? (
            <>
              <Button variant="ghost" className="w-full justify-start" onClick={() => { onOpenChange(false); onEdit?.(entry); }}>
                <Pencil className="h-4 w-4 mr-2" />{t('diet.foodEntryActions.edit')}
              </Button>
              <Button variant="ghost" className="w-full justify-start" onClick={() => setDuplicateOpen(true)}>
                <Copy className="h-4 w-4 mr-2" />{t('diet.foodEntryActions.duplicate')}
              </Button>
              <Button variant="ghost" className="w-full justify-start text-red-500 hover:text-red-600" onClick={() => { onOpenChange(false); onDelete?.(entry); }}>
                <Trash2 className="h-4 w-4 mr-2" />{t('diet.foodEntryActions.delete')}
              </Button>
            </>
          ) : (
            MEAL_TARGETS.filter(m => m !== currentMealType).map(meal => (
              <Button key={meal} variant="ghost" className="w-full justify-start" onClick={() => { onOpenChange(false); onDuplicate?.(entry, meal); }}>
                {t(`diet.foodEntryActions.duplicate${meal[0].toUpperCase() + meal.slice(1)}`)}
              </Button>
            ))
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
